import React, {Component} from 'react'
import MapsUserMenu from './_MapsUserMenu'
import firebase from '../Configs/firebase'

class MapsMenu extends Component {
    constructor(props) {
        super(props)
        
        this.handleClick = this.handleClick.bind(this)
        this.handleCancle = this.handleCancle.bind(this)
        this.updateToFirebase = this.updateToFirebase.bind(this)
    }

    updateToFirebase(){
        const { setEdited, currentPlan, deleteShapes, getPlan, setCurrentDroneLayer, setSelectedShape, setLoaded, setIsOpenSavingModal } = this.props
        setIsOpenSavingModal(true)
        var droneIdArray = []
        var layerSetting = []
        if(currentPlan.droneLayersArray !== []){
            currentPlan.droneLayersArray.forEach(layer=>{
                droneIdArray.push(layer.uid)
                layerSetting.push({is_hidden:false})
            })
        }
        var midpoint = null
        if( currentPlan.markerCoord !== null && currentPlan.markerCoord !== undefined && currentPlan.markerCoord !== '' ){
            midpoint = new firebase.firestore.GeoPoint(currentPlan.markerCoord.lat,currentPlan.markerCoord.lng)
        }
        firebase.firestore().collection('plans').doc(currentPlan.uid).update({
            address:currentPlan.address,
            deed:currentPlan.deed,
            description:currentPlan._description,
            name:currentPlan.name,
            layers:droneIdArray,
            layers_settings:layerSetting,
            midpoint:midpoint,
            uid:firebase.auth().currentUser.uid,
            created_date:currentPlan.createdAt,
            updated_date:new Date()
        })
        .then(()=>{
            var promise = []
            this.setState({planId:currentPlan.uid})
            this.props.currentPlan.shapesArray.forEach(shape => {
                var geoPoint = []
                var pro = null
                shape.coordsArray.forEach(coord=>{
                    var point = new firebase.firestore.GeoPoint(coord.lat,coord.lng)
                    geoPoint.push(point)
                })
                if(shape.uid === ''){
                    pro = firebase.firestore().collection('shapes').add({
                        plan:currentPlan.uid,
                        points:geoPoint,
                        created_date:new Date(),
                        updated_date:new Date(),
                        type:shape.type,
                        uid:firebase.auth().currentUser.uid,
                        name:shape.name,
                        description:shape.description
                    })
                } else {
                    pro = firebase.firestore().collection('shapes').doc(shape.uid).update({
                        plan:currentPlan.uid,
                        points:geoPoint,
                        created_date:shape.createdAt,
                        updated_date:new Date(),
                        type:shape.type,
                        uid:firebase.auth().currentUser.uid,
                        name:shape.name,
                        description:shape.description
                    })
                }
                
                promise.push(pro)
            })
            return Promise.all(promise)
        })
        .then((docs)=>{
            var shapes = []
            var objs = currentPlan.shapesArray.filter(obj=>{
                return obj.uid !== ''
            })
            objs.forEach(obj=>{
                shapes.push(obj.uid)
            })
            docs.forEach(doc=>{
                if(doc !== undefined) shapes.push(doc.id)
            })
            return firebase.firestore().collection('plans').doc(currentPlan.uid).update({
                shapes:shapes
            })
        })
        .then(()=>{
            var promise = []
            deleteShapes.forEach(shape=>{
                var pro = firebase.firestore().collection('shapes').doc(shape.uid).delete()
                promise.push(pro)
            })
            return Promise.all(promise)
        })
        .then(()=>{
            setEdited(false)
            setLoaded(false)
            setSelectedShape(null)
            setCurrentDroneLayer(null)
            getPlan(this.state.planId)
            window.history.pushState("","","/plan/"+this.state.planId)
        })    
    }

    handleClick(){
        const {setShowMenu} = this.props
        setShowMenu(true)
    }

    handleCancle(){
        const { setEdited, setCurrentPlan, currentPlan, getPlan, setSelectedShape } = this.props
        var r = window.confirm('คุณต้องบันทึกการเปลี่ยนแปลงก่อนปิดโปรเจคหรือไม่')
        if(r){
            this.updateToFirebase()
        }
        else{
            getPlan(currentPlan.uid)
            setCurrentPlan(currentPlan)
            setSelectedShape(null)
            setEdited(false)
        }
    }

    render(){
        const { isShowMenu, setShowMenu, user, isEdited } = this.props
        var menuOutput = null

        if( isShowMenu === false ){
            if(isEdited ){
                menuOutput =    <div  className = "button is-black is-circle is-shadow" onClick={this.handleCancle}>
                                    <span className = "icon has-text-primary"><i className = "fas fa-times"></i></span>
                                </div>
            } else {
                menuOutput =    <div className = "button is-black is-circle is-shadow" onClick={this.handleClick}>
                                    <span className = "icon has-text-primary"><i className = "fas fa-bars"></i></span>
                                </div>  
            }
        } else{
            menuOutput =    <MapsUserMenu user={user} setShowMenu={setShowMenu} setIsOpenHelpAndFeedback={this.props.setIsOpenHelpAndFeedback} />
        } 
        return(
            <div className = "MapsMenu">
                {menuOutput}
            </div>
        )
    }
}

export default MapsMenu


// WEBPACK FOOTER //
// ./src/PageMaps/_MapsMenu.js